import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { withRouter } from 'kts-platform-frame/routes';
import { Form, Button, Row, Col, Input, Select, DatePicker, Divider, Icon, Upload, message } from 'antd';
import { create } from 'kts-scaffold-framework/utils/form';
import ModulesFormAction from './Modules.Form.Action';

import { serverDomain } from 'kts-platform-frame/entry/configUtils';
import { Urls } from 'kts-platform-frame/entry/constant';
import { reducers, MyStore } from 'kts-platform-frame/redux';

import moment from 'moment';

const Option = Select.Option;
const { TextArea } = Input;
const FormItem = Form.Item;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    // validateFields(fieldNames: Array<string>, options: Object, callback: ValidateCallback): void;
}))
export default class UIComponents extends UIBasic<IProps, ModulesState, {}> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    render() {
        const { form } = this.props; // 获取你的props数据
        const { getFieldDecorator } = form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 19 },
            },
        };
        const messageInfos = this.modulesState.messageInfos;
        return (
            <Form className={css.commonFormAdditional}>
                <Row>
                    <Col span={11}>
                        <Row>
                            <Col span={24}>
                                <FormItem
                                    {...formItemLayout}
                                    label="发货时间"
                                >
                                    {getFieldDecorator('DeliveryDate', {
                                        initialValue: ModulesAction.timeStampToFormat(this.modulesState.despatchAdviceForm.DeliveryDate),
                                        rules: [{
                                            required: false,
                                            message: '选择发货时间',
                                            ...ModulesAction.getExtraRules('DeliveryDate', false)
                                        }],
                                    })(
                                        <DatePicker
                                            showTime={{ format: this.modulesState.timeFormat }}
                                            placeholder=""
                                            style={{ width: '100%' }}
                                            format={this.modulesState.dateFormat}
                                            disabledDate={ModulesAction.disabledDate}
                                            onChange={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'DeliveryDate',
                                                fieldType: 'DocField',
                                                line: null,
                                                value: moment(e).valueOf(),
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('DeliveryDate'))}
                                </FormItem>
                            </Col>
                            <Col span={15}>
                                <FormItem label="运输信息" labelCol={{ span: 8 }} wrapperCol={{ span: 15 }}>
                                    {getFieldDecorator('TransportModeCode', {
                                        initialValue: this.modulesState.despatchAdviceForm.TransportModeCode
                                    })(
                                        <Select
                                            placeholder="选择运输方式"
                                            onChange={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'TransportModeCode',
                                                fieldType: 'DocField',
                                                line: null,
                                                value: e,
                                            })}
                                        >
                                            <Option value="TMC1">水运</Option>
                                            <Option value="TMC2">火车</Option>
                                            <Option value="TMC3">陆运</Option>
                                            <Option value="TMC4">空运</Option>
                                        </Select>
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('TransportModeCode'))}
                                </FormItem>
                            </Col>
                            <Col span={9}>
                                <FormItem wrapperCol={{ span: 23, offset: 1 }} >
                                    {getFieldDecorator('TransportMeansTrackingID', {
                                        initialValue: this.modulesState.despatchAdviceForm.TransportMeansTrackingID,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^.{0,20}$/,
                                            //规则注释 message: '支持不超过20个字符',
                                            ...ModulesAction.getExtraRules('TransportMeansTrackingID', false)
                                        }],
                                    })(
                                        <Input
                                            placeholder='请输入运输工具牌号'
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'TransportMeansTrackingID',
                                                fieldType: 'DocField',
                                                line: null,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('TransportMeansTrackingID'))}
                                </FormItem>
                            </Col>
                            <Col span={15}>
                                <FormItem
                                    wrapperCol={{ span: 15, offset: 8 }}
                                >
                                    {getFieldDecorator('PerformingCarrierPartyContactName', {
                                        initialValue: this.modulesState.despatchAdviceForm.PerformingCarrierPartyContact.Name,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^.{0,20}$/,
                                            //规则注释 message: '支持不超过20个字符',
                                        }],
                                    })(
                                        <Input
                                            placeholder="联系人"
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'PerformingCarrierPartyContactName',
                                                fieldType: 'DocField',
                                                line: null,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('PerformingCarrierPartyContactName'))}
                                </FormItem>
                            </Col>
                            <Col span={9}>
                                <FormItem
                                    wrapperCol={{ span: 23, offset: 1 }}
                                >
                                    {getFieldDecorator('PerformingCarrierPartyContactPhone', {
                                        initialValue: this.modulesState.despatchAdviceForm.PerformingCarrierPartyContact.Phone,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^.{0,20}$/,
                                            //规则注释 message: '支持不超过20个字符',
                                        }],
                                    })(
                                        <Input
                                            placeholder="联系电话"
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'PerformingCarrierPartyContactPhone',
                                                fieldType: 'DocField',
                                                line: null,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('PerformingCarrierPartyContactPhone'))}
                                </FormItem>
                            </Col>
                            <Col span={24}>
                                <FormItem
                                    wrapperCol={{ span: 19, offset: 5 }}
                                >
                                    {getFieldDecorator('CarrierParty', {
                                        initialValue: this.modulesState.despatchAdviceForm.CarrierParty.Name,
                                        rules: [
                                            {
                                                required: false,
                                                //规则注释 pattern: /^.{0,50}$/,
                                                //规则注释 message: '支持不超过50个字符',
                                                ...ModulesAction.getExtraRules('PerformingCarrierPartyContactPhone', false)
                                            }
                                        ],
                                    })(
                                        <Input
                                            placeholder="承运方"
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'PerformingCarrierPartyContactPhone',
                                                fieldType: 'DocField',
                                                line: null,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('CarrierParty'))}
                                </FormItem>
                            </Col>

                            <Col span={24}>
                                <FormItem
                                    {...formItemLayout}
                                    label="备注"
                                >
                                    {getFieldDecorator('Note', {
                                        initialValue: this.modulesState.despatchAdviceForm.Note,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^[^]{0,500}$/,
                                            //规则注释 message: '支持不超过500个字符',
                                            ...ModulesAction.getExtraRules('Note', false)
                                        }],
                                    })(
                                        <TextArea
                                            placeholder=""
                                            style={{ resize: 'none' }}
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'Note',
                                                fieldType: 'DocField',
                                                line: null,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('Note'))}
                                </FormItem>
                            </Col>
                            <Col span={24}>
                                <FormItem
                                    {...formItemLayout}
                                    label="附件"
                                >
                                    {getFieldDecorator('upload', {
                                        initialValue: undefined,
                                        rules: [],
                                    })(
                                        <Upload {...ModulesAction.uploadSet()} fileList={this.modulesState.uploadList}>
                                            <Button>
                                                上传附件
                                        </Button>
                                            <span className={css.uploadTip} onClick={e => e.stopPropagation()}>支持不超过5M的文件</span>
                                        </Upload>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={11} offset={1}>
                        <Row>
                            <Col span={24}>
                                {ModulesAction.getExtraTemplate(this.modulesState.despatchAdviceForm, form, formItemLayout, false)}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
        );
    }
    /** 拼接国家列表 */
    private countryList = () => {
        let list = [];
        if (this.modulesState.countryList) {
            this.modulesState.countryList.map((item, index) => {
                list.push(<Option value={item.code} key={item.code}>{item.name}</Option>);
            });
        }
        return list;
    }
    /** 拼接省列表 */
    private provinceList = () => {
        let list = [];
        if (this.modulesState.provinceList) {
            this.modulesState.provinceList.map((item, index) => {
                list.push(<Option value={item.name} key={item.code}>{item.name}</Option>);
            });
        }
        return list;
    }
    /** 拼接市列表 */
    private cityList = () => {
        let list = [];
        if (this.modulesState.cityList) {
            this.modulesState.cityList.map((item, index) => {
                list.push(<Option value={item.name} key={item.code}>{item.name}</Option>);
            });
        }
        return list;
    }
    /** 国家下拉框改变 */
    private changeCountry = (va) => {
        this.props.form.setFieldsValue({ CountrySubentity: undefined, CityName: undefined });
        ModulesAction.getProvince(va);
    }
    /** 省下拉框改变 */
    private changeState = (va, option) => {
        this.props.form.setFieldsValue({ CityName: undefined });
        ModulesAction.getCity(va);
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/EditDocument/UI.DespatchAdviceFormAdditional.tsx